const senderAssets: Record<string, string> = {
  '3sat': '3sat.svg',
  ard: 'ard.svg',
  'ard-alpha': 'ard-alpha.svg',
  'arte.de': 'arte.svg', 'arte.en': 'arte.svg', 'arte.es': 'arte.svg',
  'arte.fr': 'arte.svg', 'arte.it': 'arte.svg', 'arte.pl': 'arte.svg',
  br: 'br.svg', dw: 'dw.png', 'funk.net': 'funk.svg', hr: 'hr.svg',
  kika: 'kika.svg', mdr: 'mdr.svg', ndr: 'ndr.svg', one: 'one.svg',
  orf: 'orf.png', phoenix: 'phoenix.svg', 'radio bremen tv': 'radio-bremen.svg',
  rbb: 'rbb.svg', rbtv: 'rbtv.jpg', sr: 'sr.svg', srf: 'srf.png',
  swr: 'swr.svg', tagesschau24: 'tagesschau24.svg', wdr: 'wdr.svg',
  zdf: 'zdf.svg', 'zdf-info': 'zdfinfo.svg', zdfinfo: 'zdfinfo.svg',
  zdfneo: 'zdfneo.svg', 'zdf-tivi': 'zdftivi.svg',
}

export function SenderLogo({ sender, compact = false }: { sender: string; compact?: boolean }) {
  const key = sender.trim().toLowerCase()
  const asset = senderAssets[key]
  return <span className={`sender-logo ${compact ? 'compact' : ''}`} title={sender}>
    {asset
      ? <img src={`/sender/${asset}`} alt="" aria-hidden="true" />
      : <span className="sender-fallback" aria-hidden="true">{sender.slice(0, 3).toUpperCase()}</span>}
    {!compact && <span>{sender}</span>}
  </span>
}

